import isApiError from "@insite/client-framework/Common/isApiError";
import { ServiceResult, get, patch } from "@insite/client-framework/Services/ApiService";

export interface GetRMAStatusDetailParamater {
    rmaReturnId: string;
}

export interface orderReturnHistoryDetailModel {
    rmaReturnID: string;
    customerPO: string;
    contactName: string;
    phoneNumber: string;
    email: string;
    uri: string;
    properties: {};
    ordersRetrunHistoryLineModel: ReturnDetailViewOrderLineModel[];
}

export interface ReturnDetailViewOrderLineModel {
    id: string;
    productId: string;
    productName: string;
    productUri: string;
    productImageUri: string;
    productCategory: string;
    productModel: string;
    adiPartNumber: string;
    returnStatus: string;
    returnReason: string;
    orderNo: string;
    returnOption: string;
    returnOptionNotes: string;
    rejectReason: string;
    trackingNumber: string;
    trackingUrl: string;
}

const url = "/api/v1/returns/getReturnHistoryOrderDetails";

export async function updateRMAStatus(parameter: GetRMAStatusDetailParamater): Promise<ServiceResult<orderReturnHistoryDetailModel>> {
    try {
        const result = await get<orderReturnHistoryDetailModel>(`${url}?`, parameter as any );
        return {
            successful: true,
            result,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}
